import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../auth/session';

const GuestRoute = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/dashboards/crm" replace />;
  }

  return children;
};

export default GuestRoute;
